import { identity } from 'lodash';

// eslint-disable-next-line
export const createSelectors =
  key =>
    (mountPointSelector = identity) => {
      const root = state => mountPointSelector(state).get(key);
      const isEditable = state => root(state).get('isEditable');
      const isLoading = state => root(state).get('isLoading');

      return {
        root,
        isEditable,
        isLoading,
      };
    };
